import { Primitive } from './ArrayUtils'
import { MapUtils } from './MapUtils'

/**
 *
 * Can be thought of as a Directed Graph, with inverse map being the arrows reversed.
 *
 * A map that stores both K,V.... and V, K pairs.
 *
 * Thus its constant time lookup in on both values and keys.
 *
 * In both directions its a many to 1 relationship. Eg. one key can have many values
 *
 * eg.
 *
 * Given pairs.
 *
 * A => 1
 * B => 1
 * B => 2
 * C => 3
 *
 * get('A') returns [1]
 * get('B') returns [1, 2]
 *
 * getInverse(1) returns Set('A', 'B')
 * getInverse(2) returns Set('B')
 */
export class BiSetMultiMap<K extends Primitive, V extends Primitive> {
  private internalMap: Map<K, Set<V>>
  private inverse: Map<V, Set<K>>

  constructor(entries: [K, V][]) {
    this.internalMap = MapUtils.buildGroupedSetMultimap(
      entries,
      ([k, _v]) => k,
      ([_k, v]) => v,
    )
    this.inverse = MapUtils.buildGroupedSetMultimap(
      entries,
      ([_k, v]) => v,
      ([k, _v]) => k,
    )
  }

  get(k: K): Set<V> {
    return this.internalMap.get(k) || new Set()
  }

  getInverse(v: V): Set<K> {
    return this.inverse.get(v) || new Set()
  }
}
